import { stateful } from '@adornis/functional-lit/stateful.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { html } from 'lit';

const HeaderBar = () => html`
  <div class="navbar rounded-box sticky top-0 z-20 flex-wrap gap-2 p-4 justify-between">
    <div class="">
      <button class="btn btn-outline" @click=${() => window.history.back()}>
        <span class="icon-[material-symbols--chevron-left] text-xl" aria-hidden="true"></span>
        Zurück
      </button>
    </div>
    <h1 class="text-center text-2xl font-semibold">Impressum</h1>
    <div class="">
      <button class="btn btn-outline" @click=${() => goTo('/')}>
        Login/Dashboard
        <span class="icon-[material-symbols--home] text-xl" aria-hidden="true"></span>
      </button>
    </div>
  </div>
`;

export const Impressum = stateful(
  () => html`
    <div class="flex flex-col bg-base-200 w-full items-center overflow-y-auto ">
      ${HeaderBar()}
      <div class="flex flex-col container gap-8 sm:mt-16 mt-8">
        <div class="card">
          <div class="card-body max-w-none gap-8 flex flex-col">
            <h2 class="font-semibold md:text-lg">Schulgesellschaft St. Martinus gGmbH</h2>

            <div class="grid grid-cols-[max-content_1fr] items-center gap-x-4 gap-y-2">
              <p class="text-sm font-semibold text-base-content/70">Anschrift:</p>
              <p>Bischofsplatz 2, 55116 Mainz</p>
              <p class="text-sm font-semibold text-base-content/70">E-Mail:</p>
              <p><a class="link link-primary" href="mailto:info@sg-sankt-martinus.de">info@sg-sankt-martinus.de</a></p>
              <p class="text-sm font-semibold text-base-content/70">Tel:</p>
              <p>06131/ 253-220</p>
              <p class="text-sm font-semibold text-base-content/70">Fax:</p>
              <p>06131/ 253-218</p>
              <p class="text-sm font-semibold text-base-content/70">Sitz der Gesellschaft:</p>
              <p>Mainz</p>
              <p class="text-sm font-semibold text-base-content/70">Amtsgericht:</p>
              <p>Mainz HRB 51233</p>
              <p class="text-sm font-semibold text-base-content/70">Steuernummer:</p>
              <p>26/675/17457</p>
              <p class="text-sm font-semibold text-base-content/70">Vertreten durch die Geschäftsführung:</p>
              <p>Uwe Brobeil</p>
              <p class="text-sm font-semibold text-base-content/70">Verantwortlich nach § 18 Abs. 2 MStV:</p>
              <p>Uwe Brobeil</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
);
